import type { QueryResult } from '@apollo/react-hooks';
import { useQuery, gql } from '@apollo/react-hooks';
import { getAssetRelatedCounts } from '#/graphql/queries';
import type { GetAssetRelatedCountsQuery } from '#/graphql/types';

const q = gql(getAssetRelatedCounts);

const useAssetRelatedCounts = (assetId: string) => {
  const { data, loading }: QueryResult<GetAssetRelatedCountsQuery> = useQuery(q, {
    variables: { assetId },
    skip: !assetId || assetId === 'new',
  });

  return { ...(data?.getAssetRelatedCounts ?? {}), loading };
};

export default useAssetRelatedCounts;
